var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dc-post-grid-pagination" }, [
    _vm.totalPages > 1 && _vm.postNavigationType === "pager"
      ? _c(
          "nav",
          { staticClass: "dc-post-grid-pager-dots" },
          _vm._l(_vm.totalPages, function(number) {
            return _c(
              "a",
              {
                class: [
                  "dc-post-grid-pager-dot",
                  {
                    active: number === _vm.currentPaged
                  }
                ],
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.goToPage(number)
                  }
                }
              },
              [
                _c("span", { staticClass: "screen-reader-text" }, [
                  _vm._v(_vm._s(number))
                ])
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("span", { staticClass: "dc-post-grid-current-page" }, [
      _vm._v(_vm._s(_vm.currentPaged) + " / " + _vm._s(_vm.totalPages))
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        class: [
          "dc-post-grid-previous",
          _vm.buttonClassString,
          {
            disabled: _vm.currentPaged <= 1
          }
        ],
        attrs: { "aria-disabled": _vm.currentPaged <= 1 },
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.changePage("previous")
          }
        }
      },
      [
        _c("span", { staticClass: "dc-button-text" }, [
          _vm._v(_vm._s(_vm.dctxt("previous")))
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        class: [
          "dc-post-grid-next",
          _vm.buttonClassString,
          {
            disabled: _vm.currentPaged >= _vm.totalPages
          }
        ],
        attrs: { "aria-disabled": _vm.currentPaged >= _vm.totalPages },
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.changePage("next")
          }
        }
      },
      [
        _c("span", { staticClass: "dc-button-text" }, [
          _vm._v(_vm._s(_vm.dctxt("next")))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }